import React, { useState } from 'react';
import PromoteModal from '../../components/PromoteModal';
import EntityPivotLink from '../../components/EntityPivotLink';
import { extractIndicators } from '../../services/intelligenceApi';

export function IntelligenceExtractor() {
  const [text, setText] = useState('');
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [promoteItem, setPromoteItem] = useState(null);
  const [promoted, setPromoted] = useState([]);

  const runExtract = async () => {
    setLoading(true);
    try {
      const res = await extractIndicators(text);
      setItems(res.data.indicators || []);
      setSelected(Object.fromEntries((res.data.indicators || []).map((item, idx) => [idx, true])));
    } catch (err) {
      console.error(err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleAll = (value) => {
    setSelected(Object.fromEntries(items.map((_, idx) => [idx, value])));
  };

  return (
    <div className="main-body">
      <h1 className="page-title">Indicator Extractor</h1>
      <p style={{ color: 'var(--hdp-text-muted)' }}>Extract IOCs from dispatches, chats, or reports — then promote selected items into the investigation graph.</p>

      <div className="card" style={{ marginTop: '18px' }}>
        <div className="card-body">
          <textarea
            className="form-input"
            rows={8}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Paste text containing indicators..."
          />
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
            <button type="button" className="btn btn-primary" disabled={loading || !text.trim()} onClick={runExtract}>
              {loading ? 'Extracting...' : 'Extract'}
            </button>
            {items.length > 0 && (
              <>
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => toggleAll(true)}>Select all</button>
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => toggleAll(false)}>Clear</button>
              </>
            )}
          </div>
        </div>
      </div>

      {items.length > 0 && (
        <div className="card" style={{ marginTop: '18px' }}>
          <div className="card-body" style={{ padding: 0 }}>
            <table className="data-table entity-table">
              <thead>
                <tr>
                  <th />
                  <th>Type</th>
                  <th>Value</th>
                  <th>Category</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={`${item.ioc_type}-${item.value}-${idx}`}>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!selected[idx]}
                        onChange={(e) => setSelected({ ...selected, [idx]: e.target.checked })}
                      />
                    </td>
                    <td><span className="entity-type-chip">{item.ioc_type}</span></td>
                    <td><code>{item.value}</code></td>
                    <td>{item.category}</td>
                    <td>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => setPromoteItem(item)}>
                        Promote
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {promoted.length > 0 && (
        <div className="card" style={{ marginTop: '18px' }}>
          <div className="card-body">
            <div className="entity-sidebar-title">Recently promoted</div>
            <div className="entity-tag-list" style={{ marginTop: '10px' }}>
              {promoted.map((item) => (
                <EntityPivotLink key={item.indicator_id} type="indicator" id={item.indicator_id} label={item.value} />
              ))}
            </div>
          </div>
        </div>
      )}

      <PromoteModal
        open={!!promoteItem}
        onClose={() => setPromoteItem(null)}
        sourceType="extractor"
        sourceId="extractor"
        sourceLabel={promoteItem?.value}
        extractedItem={promoteItem}
        onPromoted={(indicator) => {
          setPromoted((prev) => [indicator, ...prev]);
          setPromoteItem(null);
        }}
      />
    </div>
  );
}
